(function () {
  'use strict';

  var SELECTOR = '.product-single__media-image--hover-magnify';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function desktopFinePointer() {
    return window.matchMedia('(min-width: 1068px) and (hover: hover)').matches;
  }

  function upgradeImage(host) {
    var img = host.querySelector('img');
    var url = host.getAttribute('data-zoom-src');
    if (!img || !url || img.dataset.hoverMagnifyUpgraded) return;
    img.dataset.hoverMagnifyUpgraded = 'true';
    var preload = new Image();
    preload.onload = function () {
      img.src = url;
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
    };
    preload.src = url;
  }

  function bindHost(host) {
    if (host.dataset.magnifyBound === 'true') return;
    host.dataset.magnifyBound = 'true';

    var raf = 0;
    var moveEv = null;

    function flush() {
      raf = 0;
      var e = moveEv;
      if (!e || !host.classList.contains('is-hover-magnify')) return;
      var rect = host.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return;
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      var clamp = function (v) {
        return Math.max(0, Math.min(100, v));
      };
      host.style.setProperty('--zoom-x', clamp(x) + '%');
      host.style.setProperty('--zoom-y', clamp(y) + '%');
    }

    host.addEventListener('mouseenter', function () {
      if (!desktopFinePointer() || prefersReducedMotion()) return;
      upgradeImage(host);
      host.classList.add('is-hover-magnify');
    });

    host.addEventListener('mousemove', function (e) {
      if (!host.classList.contains('is-hover-magnify')) return;
      moveEv = e;
      if (!raf) raf = window.requestAnimationFrame(flush);
    });

    host.addEventListener('mouseleave', function () {
      host.classList.remove('is-hover-magnify');
      moveEv = null;
      host.style.removeProperty('--zoom-x');
      host.style.removeProperty('--zoom-y');
    });
  }

  function scan() {
    if (prefersReducedMotion() || !desktopFinePointer()) return;
    document.querySelectorAll(SELECTOR).forEach(bindHost);
  }

  function clearActiveStates() {
    document.querySelectorAll(SELECTOR + '.is-hover-magnify').forEach(function (h) {
      h.classList.remove('is-hover-magnify');
    });
  }

  function init() {
    if (prefersReducedMotion()) return;
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(scan);
  });

  var mq = window.matchMedia('(min-width: 1068px) and (hover: hover)');
  mq.addEventListener('change', function () {
    clearActiveStates();
    if (desktopFinePointer() && !prefersReducedMotion()) scan();
  });
})();
